import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';

const money = (v) => `$${Number(v || 0).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const dt = (s) => (s ? new Date(s).toLocaleString('es-MX', { dateStyle: 'short', timeStyle: 'short' }) : '');
const CAT = { salario: ['Salario', 'bg-violet-100 text-violet-700'], pago_envios: ['Pago envíos', 'bg-sky-100 text-sky-700'],
  gasolina: ['Gasolina', 'bg-amber-100 text-amber-700'], otros: ['Otros', 'bg-slate-200 text-slate-700'] };

const Detail = ({ e, isAdmin }) => {
  if (e.category === 'salario') {
    const diff = e.assigned_salary != null ? e.amount - e.assigned_salary : 0;
    return (
      <span>👤 {e.employee_name || 'Sin empleado'}
        {isAdmin && e.assigned_salary != null && Math.abs(diff) > 0.009 && (
          <span className="ml-1 text-amber-700 font-semibold">(asignado {money(e.assigned_salary)}, {diff > 0 ? '+' : '−'}{money(Math.abs(diff))})</span>
        )}
      </span>
    );
  }
  if (e.category === 'otros') return <span>🗂️ {e.expense_type_name || 'Otro'}</span>;
  return null;
};

export const ExpensesList = ({ expenses, onCancel }) => {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';
  const total = expenses.reduce((s, e) => s + (e.amount || 0), 0);
  return (
    <div className="border rounded" data-testid="expenses-list">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-[11px] uppercase text-slate-500"><tr>
          <th className="px-3 py-2 text-left">Tipo</th><th className="px-3 py-2 text-left">Detalle</th><th className="px-3 py-2 text-left">Nota</th>
          <th className="px-3 py-2 text-left">Registró</th><th className="px-3 py-2 text-right">Monto</th>{onCancel && <th />}</tr></thead>
        <tbody className="divide-y">
          {expenses.map(e => {
            const [l, cls] = CAT[e.category] || CAT.otros;
            return (
              <tr key={e.id} data-testid={`expense-row-${e.id}`}>
                <td className="px-3 py-2"><span className={`text-[11px] font-semibold rounded px-1.5 py-0.5 ${cls}`}>{l}</span></td>
                <td className="px-3 py-2"><Detail e={e} isAdmin={isAdmin} /></td>
                <td className="px-3 py-2 text-slate-600">{e.description || '—'}{e.retroactive_reason && <div className="text-[11px] text-amber-700">Retroactivo: {e.retroactive_reason}</div>}</td>
                <td className="px-3 py-2 text-xs text-slate-500">{e.created_by_name}<div>{dt(e.created_at)}</div></td>
                <td className="px-3 py-2 text-right font-bold text-rose-600">-{money(e.amount)}</td>
                {onCancel && <td className="px-2"><Button size="sm" variant="ghost" onClick={() => onCancel(e)} className="text-rose-700 h-7 px-2 text-xs" data-testid={`cancel-expense-${e.id}`}>Cancelar</Button></td>}
              </tr>
            );
          })}
        </tbody>
        <tfoot className="bg-slate-50 font-bold"><tr><td className="px-3 py-2" colSpan={4}>Total gastos ({expenses.length})</td>
          <td className="px-3 py-2 text-right text-rose-600">-{money(total)}</td>{onCancel && <td />}</tr></tfoot>
      </table>
    </div>
  );
};
